import { useTopMarquee } from '@cannect/contexts/TopMarqueeContext'
import { LuCreditCard, LuGlobe, LuMenu, LuPercent, LuStethoscope, LuTruck, LuWallet, LuX } from 'react-icons/lu'

const items = [
  { icon: <LuCreditCard />, text: 'Pague com dois cartões, Pix ou boleto.' },
  { icon: <LuTruck />, text: 'Frete grátis em compras acima de R$2500' },
  { icon: <LuWallet />, text: 'Parcele em até 3x sem juros ou em até 12x com juros.' },
  { icon: <LuPercent />, text: '5% de desconto no PIX, sem valor mínimo.' },
  { icon: <LuGlobe />, text: 'Menor taxa de importação do mercado' },
  { icon: <LuStethoscope />, text: 'Apoio de especialistas gratuito' }
]

const pagesWithoutTopMarquee = ['/carrinho-wa', '/documentos-wa']

export default function TopMarquee() {
  const { isTopMarqueeVisible, showAppBanner, closeAppBanner, closeTopMarqueeByUser } = useTopMarquee()

  const isPageWithoutTopMarquee =
    pagesWithoutTopMarquee.includes(window.location.pathname) || window.location.pathname.includes('wa')

  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent.toLowerCase()

    if (/iphone|ipad|ipod/.test(userAgent)) {
      window.open('https://apps.apple.com/br/app/cannect/id6747205181', '_blank')
    } else if (/android/.test(userAgent)) {
      window.open('https://play.google.com/store/apps/details?id=com.cannectapplife', '_blank')
    } else if (/macintosh|mac os x/.test(userAgent)) {
      window.open('https://apps.apple.com/br/app/cannect/id6747205181', '_blank')
    } else if (/windows/.test(userAgent)) {
      window.open('https://play.google.com/store/apps/details?id=com.cannectapplife', '_blank')
    } else {
      window.open('https://play.google.com/store/apps/details?id=com.cannectapplife', '_blank')
    }
  }

  // Não renderiza nada se o TopMarquee não estiver visível
  if (!isTopMarqueeVisible && !showAppBanner) {
    return null
  }
  return (
    <>
      {/* Banner App (mobile-only) */}
      {showAppBanner && (
        <div className="fixed left-0 top-0 z-30 w-full bg-secondary-100 md:hidden">
          <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-4">
            <button
              aria-label="Fechar"
              onClick={closeAppBanner}
              className="flex h-8 w-8 items-center justify-center rounded-full border-0 text-neutral-500">
              <LuX className="h-6 w-6" />
            </button>
            <div className="flex min-w-0 flex-1 items-center gap-3">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-900 text-primary-100">
                <LuMenu className="h-4 w-5" />
              </div>
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-neutral-500">Baixe o app CANNECT</p>
                <p className="truncate text-sm text-neutral-500">faça sua consulta agora </p>
              </div>
            </div>
            <button
              onClick={handleDownloadClick}
              className="rounded-lg border-0 bg-primary-800 px-6 py-[3px] text-sm font-semibold text-white no-underline">
              Baixar
            </button>
          </div>
        </div>
      )}

      {/* TopMarquee principal */}
      {isTopMarqueeVisible && (
        <div
          className={`top-marquee text-neutral-800border-b fixed left-0 z-20 flex h-8 w-full items-center border-primary-300 bg-primary-100 text-primary-800 ${
            showAppBanner ? 'top-16 md:top-0' : 'top-0'
          }`}>
          <div className="flex h-full shrink-0 items-center border-r border-primary-300 bg-primary-200 px-4 font-semibold text-neutral-800">
            Por que a Cannect?
          </div>

          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track flex whitespace-nowrap will-change-transform">
              {items.map((item, i) => (
                <div key={i} className="flex items-center gap-2 px-4">
                  <span className="text-base">{item.icon}</span>
                  <span className="text-xs font-medium md:text-sm">{item.text}</span>
                  <span className="mx-4 opacity-40">•</span>
                </div>
              ))}
              {items.map((item, i) => (
                <div key={`clone-${i}`} className="flex items-center gap-2 px-4" aria-hidden="true">
                  <span className="text-base">{item.icon}</span>
                  <span className="text-xs font-medium md:text-sm">{item.text}</span>
                  <span className="mx-4 opacity-40">•</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <style>{`
        .top-marquee .marquee-track {
          display: inline-flex;
          animation: topmarquee 45s linear infinite;
        }
        @keyframes topmarquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); } /* -50% porque duplicamos os itens */
        }
        @media (prefers-reduced-motion: reduce) {
          .top-marquee .marquee-track { animation-play-state: paused; }
        }

        /* Ajustes de espaçamento para o header */
        .has-top-marquee #header-home {
          top: ${isPageWithoutTopMarquee ? '100px' : '32px'};
        }

        /* Ajuste do margin-top do container principal para considerar o TopMarquee.
           A altura do header vem de --header-h (publicada por HeaderUI), então não há mais
           número por breakpoint: só somamos o que fica ACIMA do header (marquee/app banner). */
        .has-top-marquee #main-app-container {
          margin-top: ${isPageWithoutTopMarquee ? '135px' : 'calc(var(--header-h, 120px) + 32px)'};
        }

        /* Mobile: considera o app banner + TopMarquee */
        @media (max-width: 767px) {
          .has-top-marquee.has-app-banner #header-home {
            top: ${isPageWithoutTopMarquee ? '100px' : '96px'}; /* 64px app banner + 32px marquee */
          }
          .has-top-marquee.has-app-banner #main-app-container {
            margin-top: ${isPageWithoutTopMarquee ? '135px' : 'calc(var(--header-h, 120px) + 96px)'};
          }
        }
      `}</style>
    </>
  )
}
